import React from 'react';

import cn from 'classnames';
import CircleSpinner from 'ui/CircleSpinner/CircleSpinner';
import Icon, { Glyph } from 'ui/icon/icon';

import css from './AuthButton.css';

interface AuthButtonProps {
    type?: 'standard' | 'icon';
    disabled?: boolean;
    isPending?: boolean;
    pendingText?: string;
    onClick: VoidFunction;
    icon: Glyph;
    iconSize?: number;
}

const CSS_AUTH_ICON_SIZE_VAR = '--auth-icon-size' as string;

const AuthButton: React.FC<AuthButtonProps> = ({
    type,
    onClick,
    disabled,
    children,
    isPending,
    pendingText,
    icon,
    iconSize,
}) => {
    return (
        <button
            style={{
                [CSS_AUTH_ICON_SIZE_VAR]:
                    typeof iconSize === 'number' ? `${iconSize}px` : undefined,
            }}
            className={cn(css.button, {
                [css.standardType]: type === 'standard',
                [css.iconType]: type === 'icon',
            })}
            disabled={disabled}
            type="button"
            onClick={onClick}
        >
            <Icon glyph={icon} />
            {!isPending && <span className={css.text}>{children}</span>}
            {isPending && (
                <>
                    {pendingText && (
                        <span className={css.text}>{pendingText}</span>
                    )}
                    <CircleSpinner />
                </>
            )}
        </button>
    );
};

export default AuthButton;
